import DOMPurify from 'isomorphic-dompurify';

/**
 * Sanitize a string for XSS attacks.
 *
 * Uses [Isomorphic DOMPurify](https://github.com/kkomelin/isomorphic-dompurify)
 * for compatibility with Next.js.
 *
 * Underlying library is [DOMPurify](https://github.com/cure53/DOMPurify).
 *
 * @param value string | Node
 * @param config SantizeConfig | undefined
 * @returns string
 */ const sanitize = (value, config = {})=>{
    const { ADD_IFRAME_SANDBOX, ALLOW_IFRAME_CHILDREN, ALLOWED_IFRAME_DOMAINS } = config;
    if (ADD_IFRAME_SANDBOX || ALLOW_IFRAME_CHILDREN || ALLOWED_IFRAME_DOMAINS) {
        /**
     * https://github.com/cure53/DOMPurify/issues/766#issuecomment-1429955205
     */ if (ALLOW_IFRAME_CHILDREN) {
            DOMPurify.addHook('uponSanitizeElement', (cn)=>{
                if (cn.tagName === 'IFRAME' && cn.innerHTML) {
                    cn.dataset.temp = cn.innerHTML;
                    cn.innerHTML = '';
                }
            });
            DOMPurify.addHook('afterSanitizeElements', (cn)=>{
                if (cn.tagName === 'IFRAME' && cn.dataset.temp) {
                    cn.innerHTML = DOMPurify.sanitize(cn.dataset.temp);
                    delete cn.dataset.temp;
                }
            });
        } else {
            DOMPurify.removeHook('uponSanitizeElement');
            DOMPurify.removeHook('afterSanitizeElements');
        }
        if (ALLOWED_IFRAME_DOMAINS) {
            DOMPurify.addHook('beforeSanitizeAttributes', (cn)=>{
                if (cn.tagName === 'IFRAME') {
                    const src = cn.getAttribute('src');
                    if (src && !ALLOWED_IFRAME_DOMAINS.some((domain)=>src.includes(domain))) {
                        cn.remove();
                    }
                }
            });
        } else {
            DOMPurify.removeHook('beforeSanitizeAttributes');
        }
        if (ADD_IFRAME_SANDBOX) {
            DOMPurify.addHook('afterSanitizeAttributes', (cn)=>{
                if (cn.tagName === 'IFRAME') {
                    cn.setAttribute('sandbox', ADD_IFRAME_SANDBOX);
                }
            });
        } else {
            DOMPurify.removeHook('afterSanitizeAttributes');
        }
    } else {
        DOMPurify.removeAllHooks();
    }
    return DOMPurify.sanitize(value, {
        ...config && config
    });
};

export { sanitize };
//# sourceMappingURL=sanitize.js.map
